export enum INFRASTRUCTURE_DEVICES {
    AccessDevice = 'access_device',
    Retransmitter = 'retransmitter',
    Gateway = 'gateway',
}
export const ENDPOINT_DEVICE = 'endpoint_device';
export const UNKNOWN_DEVICES = 'unknown-device';
export const MEASURING_DEVICES = 'measuring-device';
export const INFRASTRUCTURE_DEVICE = 'infrastructure-device'

export enum SENSORS {
    Laser = 'laser',
    Iclinometer = 'inclinometer',
    None = 'none',
}